import axios from 'axios';
import store from '../app/store.js';
import moment from 'moment';
const MorningWorkTime = ['08:45:00', '11:35:00'];
const EveningWorkTime = ['13:00:00', '15:05:00'];

class Interval {
  // interval
  // cancel
  constructor(key) {
    this.key = key;
    this.timeOffset = store.getState()['COMMON:'].timeOffset || 0;
  }

  isInRange(value, range) {
    const timeValue = moment(`${value}`, 'hh:mm:ss');
    const timeStart = moment(`${range[0]}`, 'hh:mm:ss');
    const timeEnd = moment(`${range[1]}`, 'hh:mm:ss');
    return timeValue.isAfter(timeStart) && timeValue.isBefore(timeEnd);
  }

  formatData(time) {
    return `${time.getHours()}:${time.getMinutes()}:${time.getSeconds()}`;
  }

  fetch(
    dispatch,
    funcGetData,
    funcResponseData,
    wait = 1000 * 60 * 10,
    error = null,
  ) {
    // if (!this.timeOffset) return

    this.source = axios.CancelToken.source(); //create token for calling api by axios.

    const now = new Date();
    now.setSeconds(now.getSeconds() + this.timeOffset);
    const formatedTime = this.formatData(now);
    const checkRangeMorning = this.isInRange(formatedTime, MorningWorkTime);
    const checkRangeEvening = this.isInRange(formatedTime, EveningWorkTime);
    // this.cancel = () => {}
    this.cancel = () => {
      if (this.source) {
        this.source.cancel();
      }
      clearInterval(this.interval);
      this.interval = null;
    };

    let fetch = () => {
      this.source = axios.CancelToken.source(); //create token for calling api by axios.

      this.source &&
        funcGetData(this.source)
          .then(response => {
            funcResponseData(response);
          })
          .catch(err => {
            if (error) error(err);
          });
    };
    dispatch(this.cancel);
    fetch();
    if (!(checkRangeMorning || checkRangeEvening)) return;
    this.interval = setInterval(fetch, wait);
  }
}

class ListInterval {
  arr = {};

  /**
   * Show current interval list
   */
  showCurrentIntervals() {
    let list = [];
    for (var propertyName in this.arr) {
      list.push(propertyName);
    }
    return list;
  }

  /**
   * set interval funtion by Key
   * @param {*} key unique key for each layout
   * @param {*} dispatch of redux
   * @param {Promise} funcGetData param: source (if use axios to cancel calling api) , return a promise (get data or ..)
   * @param {Function} funcResponseData resolve of promise
   * @param {Number} waitTime interval time
   */
  fetch(key, dispatch, funcGetData, funcResponseData, waitTime, error = null) {
    if (this.arr[key] != null) {
      this.arr[key].cancel('cancel call api by key: ', key);
    }

    //init interval
    var interval = new Interval(key);

    //fetch data interval
    interval.fetch(dispatch, funcGetData, funcResponseData, waitTime, error);

    //add to list
    this.arr[key] = interval;
  }

  /**
   * Clear Interval by Key
   * @param {*} key
   */
  cancel(key) {
    if (this.arr[key] != null) {
      this.arr[key].cancel();
      delete this.arr[key];
    }
  }
}

export default new ListInterval();
